export default(Userlist=[],action)=>{

    switch(action.type){
        case "FETCH_USER":
            return action.payload
        default:
                return Userlist;
}
}